export default __webpack_public_path__ + "static/m-visa-f4741a0fb0052e6d34db8f003f1e3734.png";